'use client';

import { useState, useEffect, useRef, useCallback } from 'react';

interface UseSearchFilterReturn {
  searchValue: string;
  debouncedValue: string;
  setSearchValue: (v: string) => void;
  clearSearch: () => void;
}

export function useSearchFilter(debounceMs = 300): UseSearchFilterReturn {
  const [searchValue, setSearchValue] = useState('');
  const [debouncedValue, setDebouncedValue] = useState('');
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setDebouncedValue(searchValue);
    }, debounceMs);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [searchValue, debounceMs]);

  const clearSearch = useCallback(() => {
    setSearchValue('');
    setDebouncedValue('');
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);

  return { searchValue, debouncedValue, setSearchValue, clearSearch };
}
